import React, { useContext, useEffect, useState } from "react";
import "../../../assets/AdminCss/admin_users.css";
// import { Link } from "react-router-dom";
import axios from "axios";
import ToastMessage from "../../ToastMessage";
import { AuthContext } from "../../../context/Authcontext";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/api";
// import '../../../assets/AdminCss/add_roles.css'

const base_url = process.env.REACT_APP_API_URL;

const AdminModal = ({ modal, setModal, data, refresh, setRefresh }) => {
  const [money, setMoney]= useState();

  const auth= localStorage.getItem('admin');
  const fetchBalance= async()=> {

    const response= await api.post('/api/webapi/admin/listMember',
      {
        typeid: "1",
        pageno: 1,
        limit: 10,
        search: '',
        language: "vi",
      },
      {
        withCredentials:true,
        headers:{
          'content-type': 'application/json',
          Authorization:`${auth}`,
        }
      }
    );
    // console.log('rbhf',response);
    if(response?.status){
      const bal= response?.data.datas;
      // console.log('ball',bal);

      bal?.map((ball)=> {
        if(ball.token===auth){
          // console.log('monn',ball.money);
          setMoney(ball.money);
        }
      });
    }
  }
  // console.log('joe',data);
  useEffect(()=>{
    fetchBalance();
  },[])

  const renderModalComponent = () => {
    if (modal?.action === "add-admin") return <AddAdminModal setModal={setModal} data={data}/>;
    // if (modal?.action === "add") return <AddModal />;
    if (modal?.action === "chips-in-out")
      return (
        <ChipsInOut refresh={refresh} setRefresh={setRefresh} setModal={setModal} data={data[0]} />
      );

    // User-specific modal (UserShowModal)
    if (modal?.action === "user-show") {
      const selectedUser = data.find((user) => `${user.id}` === `${modal.id}`);
      // console.log('selevcted',selectedUser);
      const auth= localStorage.getItem('admin');
      // console.log(data,'data');
      // const mainUser= data.find((user)=> user && user.token===auth);

      // console.log(auth,'aaa');
      // console.log('mainn',mainUser);
      if (selectedUser) {
        return (
          <UserShowModal
            refresh={refresh}
            setRefresh={setRefresh}
            setModal={setModal}
            user={selectedUser}
            avail={money}
          
          />
        );
      } else {
        return <p>User not found!</p>;
      }
    }

    return null;
  };

  return (
    <>
      <div className={`${modal?.action !== null ? "show_modal" : "loginbox"}`}>
        {money &&<div
          className="close_btn closeButtonSiderbar"
          onClick={() => setModal({ action: null, id: null })}
        >
          <button
            type="button"
            className="btn btn-danger search_user_close1"
            fdprocessedid="331xx8"
          >
            <i className="sidebar-mini-x" />
          </button>
        </div>}
        <div className="loginform">
          <div className="clearfix" />
          <div className="clearfix" />
          <div id="showresult">{renderModalComponent()}</div>
        </div>
      </div>
    </>
  );
};

const AddAdminModal = ({ setModal, data}) => {
  const [invite, setInvite]= useState();
  const [commission, setCommission]= useState();
  const [originalCommission, setOriginalCommission] = useState(0);
  const [track, setTrack]= useState(0);
  const { getRoles } = useContext(AuthContext);
// console.log('data',data);
  const [roles, setRoles]= useState([]);
  const [formData, setFormData]= useState({
    phone:'',
    userName:'',
    password:'',
    confirmPassword:'',
    commission:'',
    role:'',
    invite: '',
    logCommission:0,
    limit:0,
  });

  const handleChange=(e)=> {
    if(track === 1) return;
    const {name, value}= e.target;
    const newValue= value==='' ? 0 : parseFloat(value)

    if(name==='commission'){
      if(commission===0 && track === 0){
        toast.error('Insufficient main commission');
        setTrack(1);
        return;
      }else if(newValue>100 && track === 0){
        toast.error('Never given more than 100% commission');
        setTrack(1);
        return;
      }
      // else if(newValue>commission){
      //   toast.error("Can't give commission more than granted");
      // }
      else{
        if(!newValue){
          setCommission(commission);
        }
        const remainingCommission= parseFloat(originalCommission) - parseFloat(newValue);
        // console.log('remaain',remainingCommission);
        setCommission(remainingCommission);
      }

    }


    setFormData({
      ...formData,
      [name]:value,
    });

  };

  const handleAddSubmit= async(e)=> {
    e.preventDefault();

    const { phone, userName, password, confirmPassword, role } = formData;
    // console.log(formData);
    if ((!phone || !userName || !password || !confirmPassword || !role) && track === 0 ) {
      toast.error("All fields are required!");
      setTrack(1);
      return;
    }
  
    // Example: Show specific field error
    if (!phone && track === 0) {
      toast.error("Phone number is required!");
      setTrack(1);
      return;
    }
    if (!userName && track === 0) {
      toast.error("Username is required!");
      setTrack(1);
      return;
    }
    if (!password && track === 0) {
      toast.error("Password is required!");
      setTrack(1);
      return;
    }
    if (password !== confirmPassword && track === 0) {
      toast.error("Passwords do not match!");
      setTrack(1);
      return;
    }
  
    // If everything is filled, proceed with submission
    // toast.success("Form submitted successfully!");

    // console.log('frm',formData);

    const auth= localStorage.getItem('admin');
    try{
      // console.log('formdata',formData);
      const response= await api.post('/api/webapi/add/user',
        formData,
        {
          withCredentials:true,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization:`${auth}`,
          }
        }
      );
      // console.log('resppp',response);

      if(response?.data.status){
        toast.success(response?.data.message);
        setFormData('')
        setModal(false);
        window.location.reload();
      }else{
        if(track === 0){
          toast.error(response?.data.message);
          setTrack(1);
        }
      }

    }catch(error){
      console.log('error',error);
      // toast.error(error?.response.data.message);
    }
  };

  const roleList= async(req,res)=> {
    const auth= localStorage.getItem('admin');
    const role= localStorage.getItem('role');

    try{
      const list= await getRoles(auth, role);

      // console.log('list',list);

      list.map((ls)=>{
        const value= Object.values(ls);

        value.map((val)=> {
          const k= Object.values(val);

          k.forEach(ky=>{
            const kee=Object.keys(ky);

            kee.map((kl)=> {
              let arr=[]

              if(kl==='user'){
                const vvv=Object.values(ky);

                vvv.forEach(each=> {
                  // arr.push(each);
                  // console.log('eacb',each);

                  each.map((mp)=> {
                    arr.push(mp);
                  })
                })
                setRoles(arr);
              }
          })
        })
      })
    })
    }catch(err){
      console.log('err',err);
    }
    
  }


  useEffect(()=> {

    const loggedUser= async()=>{
      try{
        const auth= localStorage.getItem('admin');

        const response= await api.get('/api/webapi/logUser',
          {
            headers:{
              'content-type':'application/json',
              Authorization:`${auth}`,
            }
          }
        );

        // console.log(response);
        const data= response?.data.row[0];


        console.log("data is of th ------------------------ " , data);

        setInvite(data?.code);
        setCommission(data?.givecommission);
        setOriginalCommission(data?.givecommission);

      }catch(err){
        console.log(err);
      }
    }

    // const loggedin= data;
    // // console.log('logg',loggedin);
    // const foundUser= loggedin.find((logg)=> logg.token===auth);
    // setInvite(foundUser.code);
    // setCommission(foundUser.commission);
    // setOriginalCommission(foundUser.commission);

    roleList();
    loggedUser();

  },[]);
  // console.log('roll',roles);

  useEffect(()=>{

    const timer= setTimeout(()=>{
      setTrack(0);
    },5000);

    return ()=>clearTimeout(timer);
  },[track]);

  formData.invite=invite;
  formData.logCommission= commission;

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div
        className="clearfix padded addsupermasterformdiv"
        id="adminadd"
        style={{ display: "block" }}
      >
        <div className="tab-pane padded">
          <div className="form-sec">
            <label style={{ fontWeight: "bold" }}>Add Admin</label>
            <hr />
            <form
              name="qryform"
              className="form add_supermaster_master_form addusers"
              onSubmit={handleAddSubmit}
            >
              <div className="form-row1">
              <div className="form-group col-md-6 padded">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control validate[required]"
                    placeholder="User Name"
                    name="userName"
                    id="master_super_master_name"
                    value={formData.username}
                    onChange={handleChange}
                    fdprocessedid="a4xs9a"
                  />
                  <span className="error" id="master_super_master_name_error" />
                </div>
                <div className="form-group col-md-6 padded">
                  <label>User Name:</label>
                  <input
                    type="text"
                    className="form-control validate[required,custom[onlyLetterNumber]]"
                    placeholder="Enter user name"
                    name="phone"
                    id="master_super_master_user_id"
                    value={formData.id}
                    onChange={handleChange}
                    fdprocessedid="531mr4"
                  />
                  <span
                    className="error"
                    id="master_super_master_user_id_error"
                  />
                </div>
          
              </div>
              <div className="clearfix" />
              <div className="form-row1">
                <div className="form-group  col-md-6 padded">
                  <label>Password:</label>
                  <input
                    type="password"
                    className="form-control validate[required]"
                    placeholder="Password"
                    name="password"
                    id="master_super_master_password"
                    fdprocessedid="8h9af"
                    value={formData.plain_password}
                    onChange={handleChange}
                  />
                  <span
                    className="error"
                    id="master_super_master_password_error"
                  />
                </div>
                <div className="form-group  col-md-6 padded">
                  <label>Confirm Password:</label>
                  <input
                    type="password"
                    className="form-control validate[required,equals[master_super_master_password]]"
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    id="master_super_master_confirm_password"
                    fdprocessedid="6353w9"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                  <span
                    className="error"
                    id="master_super_master_confirm_password_error"
                  />
                </div>
              </div>

              <div className="form-row1">
              <div className="form-group col-md-6 padded">
              <label>Role</label>
                  <div className="custom-select-wrapper">                  
                  <select className="form-control custom-select" name="role" value={formData.role} onChange={handleChange}>                  
                    <option value=''>select role  <i className="fa fa-chevron-down dropdown-icon"></i></option>
                    {roles
                      .filter(role => role !== 'A/C chips In/Out' && role !== 'View More/Edit' && role !== 'Add Admin')
                      .map((role, index) => (
                        <option key={index} value={role}>{role}</option>
                      ))
                    }

                  </select>
                  <i className="fa fa-chevron-down dropdown-icon"></i>
                  </div>
        
                </div>

              <div className="form-group col-md-6 padded">
                  <label>Invite</label>
                  <input
                    type="text"
                    className="form-control validate[required,custom[onlyLetterNumber]]"
                    placeholder="Enter commission percent"
                    name="code"
                    id="master_super_master_user_id"
                    value={formData.invite}
                    onChange={handleChange}
                    fdprocessedid="531mr4"
                    readOnly
                  />
                  <span
                    className="error"
                    id="master_super_master_user_id_error"
                  />
                </div>

                
          
              </div>
              <div className="clearfix" />
              <div className={`form-row1 ${formData.role && formData.role !=='user' ? '' : 'd-none'} `}>
            
                <div className="form-group col-md-6 padded">
                  <label>Sharing %</label>
                  <input
                    type="text"
                    className="form-control validate[required,custom[onlyLetterNumber]]"
                    placeholder="Enter commission percent"
                    name="commission"
                    id="master_super_master_user_id"
                    value={formData.commission}
                    onChange={handleChange}
                    fdprocessedid="531mr4"
                  />
                  <span
                    className="error"
                    id="master_super_master_user_id_error"
                  >{commission}%</span>
                </div>

                {/* <div className="form-group col-md-6 padded">
                  <label>Login Limit</label>
                  <input
                    type="text"
                    className="form-control validate[required,custom[onlyLetterNumber]]"
                    placeholder="Enter login device limit"
                    name="limit"
                    id="master_super_master_user_limit"
                    value={formData.limit}
                    onChange={handleChange}
                    fdprocessedid="531mr4"
                  />
                  <span
                    className="error"
                    id="master_super_master_user_id_error"
                  />
                </div> */}
          
              </div>
              <button className="btn btn-info w-100">Submit</button>
              
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

const ChipsInOut = ({data, setModal}) => {
  // console.log('ddd',data);
  const [newData, setNewData] = useState({
    adminChips: "",
    adminReference: "",

  });
  const [TotalMoney, setTotalMoney] = useState();
  const [track, setTrack]= useState(0);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewData({
      ...newData,
      [name]: value,
    });
  };

  const handleSubmit = async (e, action) => {
    e.preventDefault();
    if ((newData.adminChips === "" || newData.adminReference === "") && track === 0) {
      toast.error("All field must be required");
      setTrack(1);
      return;
    }
    const auth = localStorage.getItem("admin");
    try {
      const api1 =
        action === "deposit"
          ? "/api/webapi/admin/deposit/update"
          : "/api/webapi/admin/withdraw/update";

      if ((newData.adminChips === "" || newData.adminReference === "") && track === 0) {
        ToastMessage("Missing Fields");
        setTrack(1);
        return;
      }
      const response = await api.post( api1, newData, {
        withCredentials: true,
        headers: {
          "content-type": "application/json",
          Authorization: `${auth}`,
        },
      });
      // console.log("je", response.status);
      if (response?.status) {
        if (action === "deposit") {
          setTotalMoney(TotalMoney + parseFloat(newData.adminChips));
        }
        if (action === "withdraw") {
          setTotalMoney(TotalMoney - parseFloat(newData.adminChips));
        }
        toast.success("Request approved");
        setTrack(1);
      } else {
        ToastMessage(0, "Failed to accept request");
        setTrack(1);
      }
      setModal(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {

    const loggedUser= async()=>{
      try{
        const auth= localStorage.getItem('admin');

        const response= await api.get('/api/webapi/logUser',
          {
            headers:{
              'content-type':'application/json',
              Authorization:`${auth}`,
            }
          }
        );

        // console.log(response);
        const data= response?.data.row[0];

        setTotalMoney(parseFloat(data?.money));

      }catch(err){
        console.log(err);
      }
    }


    loggedUser();
  }, []);
  useEffect(()=>{
    const timer= setTimeout(()=>{
      setTrack(0);
    },5000);

    return ()=>clearTimeout(timer);
  },[track]);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div
        className="clearfix padded"
        id="chips_deposit_withdrawl"
        style={{ display: "block" }}
      >
        <div className="padded">
          <div className="form-sec">
            <label style={{ fontWeight: "bold" }}>
              A/C Chips In/Out for superadmin
            </label>{" "}
            <br />
            <label>
              <strong>
                Available Balance : <span id="adminamount1">{TotalMoney}</span>
              </strong>
            </label>
            <hr />
            <form name="qryform" className="form admin_self_chips_in_out">
              <div className="form-row row1">
                <div className="form-group col-md-6">
                  {/* <input type="type" defaultValue="mono" id="mono" hidden /> */}
                  <label>Chips</label>
                  <input
                    type="number"
                    name="adminChips"
                    id="amount"
                    className="form-control"
                    value={newData.adminChips}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>Reference</label>
                  <input
                    type="text"
                    name="adminReference"
                    id="admin_chips_reference"
                    className="form-control"
                    value={newData.adminReference}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <button
                  href=";"
                  className="btn btn-success w-50"
                  id="chipsDeposit"
                  onClick={(e) => handleSubmit(e, "deposit")}
                  style={{ textDecoration: "none" }}
                >
                  DEPOSIT
                </button>
                <button
                  href=";"
                  className="btn btn-info w-50"
                  id="chipsWithdrawl"
                  onClick={(e) => handleSubmit(e, "withdraw")}
                  style={{ textDecoration: "none" }}
                >
                  WITHDRAWL
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

const UserShowModal = ({user, setModal, avail}) => {
  // const navigate= useNavigate();
  // console.log('userrr',main);
  const [commission, setCommission]= useState();
  const [originalCommission, setOriginalCommission] = useState(0);
  const [phonee, setPhonee]= useState();
  const [debitt, setDebitt]= useState(0);
  const [credd, setCredd]= useState(0);
  const [track, setTrack]= useState(0);

  const [formData, setFormData] = useState({
    id:user.id,
    username:user.username ,
    money: user.money,
    plain_password: user.plain_password,
    phone:user.phone,
    debit: 0,
    debitRemark: "",
    bonus_money: user.bonus_money,
    role: user.role,
    commission:user.commission,
    available:avail,
    mainPhone:'',
    type:'',
    logCommission:0,
    limit:user.loginLimit,
    utr:'',
  });


  const handleChange = (e) => {
    // console.log(e.target.value);
    const { name, value } = e.target;
    // console.log('name:', name , "value:", value);
    const newValue= value===''? 0 : value;
    if(name==='commission'){
      if(commission===0 && track === 0){
        toast.error('Insufficient main commission');
        setTrack(1);
      }else if(newValue>100 && track === 0){
        toast.error('Never given more than 100% commission');
        setTrack(1);
      }
      // else if(newValue>commission){
      //   toast.error("Can't give commission more than granted");
      // }
      else{
        if(!value){
          setCommission(commission);
        }
        const remainingCommission= parseFloat(originalCommission) - parseFloat(newValue);
        // console.log('remaain',remainingCommission);
        setCommission(remainingCommission);
      }

    }
    if (
      name === "money" ||
      name === "commssion" ||
      name === "debit" ||
      name === "bonus_money" || 
      name === "limit" ||
      name === 'utr'
    ) {
      const validateValue = value.replace(/[^0-9]/g, "");

      // console.log(name, ":", value);
      setFormData({
        ...formData,
        [name]: validateValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log('frm',formData);

    try {
      const auth = localStorage.getItem("admin");
      const response = await api.post( "/api/webapi/admin/updateData",
        formData,
        {
        headers: {
          "content-type": "application/json",
          Authorization: `${auth}`,
        },

      });

      // console.log('ewuvdhbcsjn',response);
      if (response?.data.success && track === 0) {
        toast.success("User Updated Successfully");
        setTrack(1);
        setModal(false);
        window.location.reload();
      } else {
        toast.error("Failed to update data");
        setTrack(1);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = (action) => {
    if (track === 1) return;
    const money = parseFloat(formData.money);
    const debitAmount = parseFloat(formData.debit);

    if (!formData.debit && track === 0) {
      toast.error("Please enter amount");
      setTrack(1);
      return;
    }

    if (action === 0 && money < debitAmount && track === 0) {
      toast.error("Insufficient Main balance");
      setTrack(1);
      return;
    }

    if (action === 1 && track === 0 && parseFloat(formData.available) < debitAmount) {
      toast.error("Not enough logged in role balance");
      setTrack(1);
      return;
    }

    // First update the debitt/credd state
    if (action === 0) {
      setDebitt((prevDebitt) => {
        const updatedDebitt = prevDebitt + debitAmount;

        // After updating debitt, now update formData using the new max value
        setFormData((prevData) => {
          const updatedMoney = parseFloat(prevData.money) - debitAmount;
          const updatedAvailable = parseFloat(prevData.available) + debitAmount;

          const maxValue = Math.max(updatedDebitt, credd); // use latest debitt
          console.log('debit max value',maxValue);
          return {
            ...prevData,
            type: 'debit',
            money: parseFloat(updatedMoney.toFixed(2)),
            available: parseFloat(updatedAvailable.toFixed(2)),
            debit: maxValue, // reflect max(debitt, credd)
          };
        });

        return updatedDebitt;
      });
    } else {
      setCredd((prevCredd) => {
        const updatedCredd = prevCredd + debitAmount;
        

        // After updating credd, now update formData using the new max value
        setFormData((prevData) => {
          const updatedMoney = parseFloat(prevData.money) + debitAmount;
          const updatedAvailable = parseFloat(prevData.available) - debitAmount;

          const maxValue = Math.max(debitt, updatedCredd); // use latest credd
          // console.log('debit max value',maxValue);
          return {
            ...prevData,
            type: 'credit',
            money: parseFloat(updatedMoney.toFixed(2)),
            available: parseFloat(updatedAvailable.toFixed(2)),
            debit: maxValue, // reflect max(debitt, credd)
          };
        });

        return updatedCredd;
      });
    }
  };




 
useEffect(() => {

  const loggedUser= async()=>{
      try{
        const auth= localStorage.getItem('admin');

        const response= await api.get('/api/webapi/logUser',
          {
            headers:{
              'content-type':'application/json',
              Authorization:`${auth}`,
            }
          }
        );

        // console.log(response);
        const data= response?.data.row[0];

        setPhonee(data?.phone);
        setCommission(data?.givecommission);
        setOriginalCommission(data?.givecommission);

      }catch(err){
        console.log(err);
      }
  }


  loggedUser();
}, []);

useEffect(() => {
  if (track === 1) {
    const timer = setTimeout(() => {
      setTrack(0);
    }, 5000);

    return () => clearTimeout(timer); // cleanup
  }
}, [track]);


 formData.mainPhone=phonee;
  formData.logCommission= commission;

  

 
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div
        className="tab-pane active1 padded"
        id="inner_tab_content_3"
        style={{ display: "block" }}
      >
        <div className="form-sec">
          <label style={{ fontWeight: "bold" }}>User Details</label>
          <hr />
          <form
            name="qryform"
            className="form addmasterorsupermasterform_10019 addusers"
            onSubmit={handleSubmit}
          >
            <div className="form-row">
              <div className="form-group col-md-6 padded">
                <label>User ID:</label>
                <input
                  type="text"
                  className="form-control validate[required]"
                  name="id"
                  id="master_name_10019"
                  value={formData.id}
                  disabled
                />
                <span className="error" id="master_name_error_10019" />
              </div>
              <div className="form-group col-md-6 padded">
                <label>Full Name:</label>
                <input
                  type="text"
                  className="form-control validate[required,custom[onlyLetterNumber]]"
                  placeholder="Enter User Name"
                  name="username"
                  id="masteruserid10019"
                  value={formData.username}
                  onChange={handleChange}
                />
                <span className="error" id="master_user_id_error_10019" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6 padded">
                <label>Phone Number</label>
                <input
                  type="text"
                  className="form-control validate[required]"
                  placeholder="Enter Phone number"
                  name="phone"
                  id="master_name_10019"
                  value={formData.phone}
                  disabled
                />
                <span className="error" id="master_name_error_10019" />
              </div>
              <div className="form-group col-md-6 padded">
                <label>Password:</label>
                <input
                  type="text"
                  className="form-control validate[required,custom[onlyLetterNumber]]"
                  placeholder="Enter password"
                  name="plain_password"
                  id="masteruserid10019"
                  value={formData.plain_password}
                  onChange={handleChange}
                />
                <span className="error" id="master_user_id_error_10019" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6 padded">
                <label>Main Balance:</label>
                <input
                  type="text"
                  className="form-control validate[required]"
                  placeholder="Enter money"
                  name="money"
                  id="master_name_10019"
                  value={formData.money}
                  disabled
                />
                <span className="error" id="master_name_error_10019" />
              </div>

                <div>
                  <label>Available balance:</label>
                  <input type='text' className="form-control mt-2" name="available" value={formData.available} readOnly/>
                </div>

              
            </div>

            <div className="form-row">
              <div className=" col-md-6 padded">
                <div>
                  <label>Deposit/Withdraw:</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Debit Amount"
                    name="debit"
                    id="master_name_10019"
                    value={formData.debit}
                    onChange={handleChange}
                  />
                </div>
                {/* <span className="error" id="master_name_error_10019" /> */}
                {formData.debit > 0 && (
                  <div className="d-flex flex-column form-group mt-2">
                    <label>Remark:</label>
                    <textarea
                      type="text"
                      placeholder="Enter Remark for Debit"
                      name="debitRemark"
                      value={formData.debitRemark}
                      onChange={handleChange}
                      id="debitRemark"
                    />
                  </div>
                )}

              <div className="d-flex gap-3">
                <p
                  className="btn btn-success"
                  style={{ height: "2.5rem" }}
                  onClick={() => handleClick(0)}
                >
                  Withdraw
                </p>
                <p
                  className="btn btn-primary"
                  style={{ height: "2.5rem" }}
                  onClick={() => handleClick(1)}
                >
                  Deposit
                </p>
              </div>
            </div>

             <div className="form-group col-md-6 padded">
                <label>Utr Number:</label>
                <input
                  type="text"
                  className="form-control validate[required]"
                  placeholder="Enter utr"
                  name="utr"
                  id="master_name_10019"
                  value={formData.utr}
                  onChange={handleChange}
                  minLength={6}
                />
                <span className="error" id="master_name_error_10019" />
              </div>
            
            </div>

            <div className="form-row mt-3">

              <div className="form-group col-md-6 padded">
                <label>Bonus Money:</label>
                <input
                  type="text"
                  className="form-control validate[required]"
                  placeholder="Enter Name"
                  name="bonus_money"
                  id="master_name_10019"
                  value={formData.bonus_money}
                  onChange={handleChange}
                />
                <span className="error" id="master_name_error_10019" />
              </div>
             

              <div className="form-group col-md-6 padded">
                <label>Role:</label>
                <input
                  type="text"
                  className="form-control validate[required,custom[onlyLetterNumber]]"
                  placeholder="Enter User Role"
                  name="role"
                  id="masteruserid10019"
                  value={formData.role}
                  onChange={handleChange}
                />
                <span className="error" id="master_user_id_error_10019" />
              </div>

              
            </div>

            {/* limt */}
            <div className="form-row mt-3">
              <div className={`form-group col-md-6 padded ${user.role === 'user' ? 'd-none' : ''} `}>
                <label>Sharing %:</label>
                <input
                  type="text"
                  className="form-control validate[required,custom[onlyLetterNumber]]"
                  placeholder="Enter commission"
                  name="commission"
                  id="masteruserid10019"
                  value={formData.commission}
                  onChange={handleChange}
                />
                <span className="error" id="master_user_id_error_10019">{commission}%</span>
              </div>

              {/* <div className={`form-group col-md-6 padded ${user.role === 'user' ? 'd-none' : ''} `}>
                <label>Login Limit:</label>
                <input
                  type="text"
                  className="form-control validate[required,custom[onlyLetterNumber]]"
                  placeholder="Enter limit of login"
                  name="limit"
                  id="masteruserid10019"
                  value={formData.limit}
                  onChange={handleChange}
                />
                <span className="error" id="master_user_id_error_10019" />
              </div> */}
            </div>

            <div className="clearfix" />
            <div className="d-flex gap-2 form-group col-md-12 padded">
              {/* button */}
              <button className="btn btn-info w-100 mt-3">Update</button>
              {/* <button
                className="btn btn-primary w-100 mt-3"
                onClick={() =>
                  navigate('/admin/userStatement', {
                    state: {
                      id3: formData.id,
                      name: "Debansh",
                    },
                  })
                }
              >
                Statement
              </button> */}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AdminModal;